// EXPERIMENTAL. Silently pre-warms the browser's HTTP cache with each
// product's first 1-3 PDP-resolution images while browsing a collection
// page, so by the time a visitor actually opens a product page, its main
// images are already cached and appear instantly instead of loading live.
//
// Deliberately unconditional (no hover/touch/viewport gating) — this is a
// first pass to measure how much bandwidth this actually costs before
// deciding whether to scale it back to something more targeted. Fires once,
// after window 'load', so it never competes with the collection page's own
// layout or images for bandwidth.
//
// Completely independent of product-item-swiper.js (the tablet/mobile card
// carousel) — reads its own dedicated <script type="application/json">
// data blobs only, never touches that file or its DOM.
(function () {
  // Mirrors the sizes="(max-width: 991px) 100vw, calc(50vw - 330px)" rule
  // on the PDP's own gallery image (sections/product_header.liquid) and the
  // matching srcset width candidates, so the exact same CDN URL gets
  // requested here as the PDP will request — otherwise this warms the
  // wrong width and the PDP still has to fetch its own copy from scratch.
  var WIDTH_CANDIDATES = [600, 900, 1200, 1600, 2000, 2400];

  function pdpTargetWidth() {
    var dpr = window.devicePixelRatio || 1;
    var cssWidth = window.innerWidth <= 991
      ? window.innerWidth
      : window.innerWidth * 0.5 - 330;
    var target = cssWidth * dpr;
    for (var i = 0; i < WIDTH_CANDIDATES.length; i++) {
      if (WIDTH_CANDIDATES[i] >= target) return WIDTH_CANDIDATES[i];
    }
    return WIDTH_CANDIDATES[WIDTH_CANDIDATES.length - 1];
  }

  function prefetchAll() {
    var width = pdpTargetWidth();
    var blobs = document.querySelectorAll('.product-item_prefetch-data');
    var total = 0;

    blobs.forEach(function (blob) {
      var urls;
      try {
        urls = JSON.parse(blob.textContent);
      } catch (e) {
        return;
      }
      urls.forEach(function (baseUrl) {
        if (!baseUrl) return;
        var img = new Image();
        img.src = baseUrl + width;
        total++;
      });
    });

    if (window.console) {
      console.log('[collection-pdp-prefetch] warmed ' + total + ' image(s) at width=' + width);
    }
  }

  window.addEventListener('load', function () {
    prefetchAll();
  });
})();
